import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { ActivatedRoute } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-confirm-mail',
  templateUrl: './confirm-mail.component.html',
  styleUrls: ['./confirm-mail.component.css']
})
export class ConfirmMailComponent implements OnInit {

  constructor(private userService: UserService,
              private activeRoute: ActivatedRoute) { }
  errors: string[];
  ok = false;
  ngOnInit() {
    const userCode = this.activeRoute.snapshot.params.token; // .queryParamMap.get('token');
    // (userCode);
    const userName = this.activeRoute.snapshot.params.id; // queryParamMap.get('id');
    // console.log(userName);
    this.errors = [];
    this.userService.ConfirmEmail(userName, userCode)
    .subscribe(res => {
            this.ok = true;
      },
      (err: HttpErrorResponse) => {
        // console.log(err);
        if (err.status === 400) {
          // this.errors.push(err.error.Message);
          this.errors.push('Ocurrio un error al confirmar su usuario.');
          for (const key in err.error.ModelState) {
            if (err.error.ModelState.hasOwnProperty(key)) {
              const element = err.error.ModelState[key];
              this.errors.push(element);
            }
          }
        }  else {
          this.errors.push('Ocurrio un error al confirmar el usuario.');
        }
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/user/confirm-mail/confirm-mail.component.ts